import React from 'react';
import FormularioModeloAnuncio from './formulario';

const CadastrarMateriaisVenda = () => {
  return (
    <FormularioModeloAnuncio />
  );
};

export default CadastrarMateriaisVenda;